import type { Api } from "./api.types";

const usersApi = {
  activeUsers: {
    key: () => ["users", "active"],
    url: () => "/api/users/active"
  }
} satisfies Api;

export { usersApi };
